var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"industry-news-list-filter"},[_c('industry-multi-select',{staticClass:"emotional",attrs:{"title":"情感","selected-filters":_vm.selectedTags.emotional,"items":_vm.newsListFilters.emotional},on:{"change":_vm.onNegativeFilterChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }